import { BRAND_ASSET_GROUPS_CRUD_ACTION_CREATORS } from '../actions/brand_asset_groups_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';

export const brandAssetGroupsRestCrudThunksForBuyer = new RestCrudThunks(
	'brand_asset_groups',
	'brand_asset_group',
	'brandAssetGroup',
	'brandAssetGroups',
	BRAND_ASSET_GROUPS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'brand/'
);

export const brandAssetGroupsRestCrudThunksForSupplier = new RestCrudThunks(
	'brand_asset_groups',
	'brand_asset_group',
	'brandAssetGroup',
	'brandAssetGroups',
	BRAND_ASSET_GROUPS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'brand/'
);
